import { Buffer } from 'buffer';

// This is to fix: https://github.com/swagger-api/swagger-ui/issues/6869
if (!('Buffer' in globalThis)) {
  globalThis.Buffer = Buffer;
}
